// extracted by mini-css-extract-plugin
export default {"groupCard":"GroupCard_groupCard__db9pI"};